import client from 'utils/contentfulService';
const getRegionsByClient = async (_, clientId) => {
  const { items } = await client.getEntries({
    content_type: 'region',
    'fields.client.sys.id[in]': clientId,
  });
  return items;
};

export default getRegionsByClient;
